/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { UserControllerGetProfileQueryResponse, UserControllerGetProfileQueryParams, UserControllerGetProfile400, UserControllerGetProfile401, UserControllerGetProfile403, UserControllerGetProfile404 } from "../../models/usersController/UserControllerGetProfile";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { userControllerGetProfile } from "../../clients/usersService/userControllerGetProfile";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const userControllerGetProfileQueryKey = (params: UserControllerGetProfileQueryParams = {}) => [{
  url: '/api/v1/users/me'
}, ...(params ? [params] : [])] as const;
export type UserControllerGetProfileQueryKey = ReturnType<typeof userControllerGetProfileQueryKey>;
export function userControllerGetProfileQueryOptions(params?: UserControllerGetProfileQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = userControllerGetProfileQueryKey(params);
  return queryOptions<UserControllerGetProfileQueryResponse, ResponseErrorConfig<UserControllerGetProfile400 | UserControllerGetProfile401 | UserControllerGetProfile403 | UserControllerGetProfile404>, UserControllerGetProfileQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return userControllerGetProfile(params, config);
    }
  });
}

/**
 * @summary Get current user profile
 * {@link /api/v1/users/me}
 */
export function useUserControllerGetProfile<TData = UserControllerGetProfileQueryResponse, TQueryData = UserControllerGetProfileQueryResponse, TQueryKey extends QueryKey = UserControllerGetProfileQueryKey>(params?: UserControllerGetProfileQueryParams, options: {
  query?: Partial<QueryObserverOptions<UserControllerGetProfileQueryResponse, ResponseErrorConfig<UserControllerGetProfile400 | UserControllerGetProfile401 | UserControllerGetProfile403 | UserControllerGetProfile404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? userControllerGetProfileQueryKey(params);
  const query = useQuery({
    ...userControllerGetProfileQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<UserControllerGetProfile400 | UserControllerGetProfile401 | UserControllerGetProfile403 | UserControllerGetProfile404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}